import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {  withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { connect } from "react-redux";
import { css } from "styled-components";
import React, { useState } from "react";
import Typography from "@insite/mobius/Typography";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";

interface OwnProps {
    orderLine?: OrderLineModel;
    cartLine?: CartLineModel;
    extendedStyles?: AdiSpecialHandlingFeeDisplayStyles
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> 


const mapStateToProps = (state: ApplicationState) => {
    return {
        session:state.context.session,
    };
};

export interface AdiSpecialHandlingFeeDisplayStyles {
    specialHandlingfeeGridContainer?: GridItemProps;
    specialHandlingfeelabelGridItem?: GridItemProps;
    specialHandlingfeeValueGridItem?: GridItemProps;
    specialHandlingfeelabel?: InjectableCss;
    specialHandlingfeeValue?: InjectableCss;
    specialHandlingfeePerItemValue?: InjectableCss
}

export const adiSpecialHandlingFeeDisplayStyles: AdiSpecialHandlingFeeDisplayStyles = {
    specialHandlingfeeGridContainer: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            justify-content: space-between;
            @media print {
                width: 100%;
                float: left;
            }
             `,
    },

 specialHandlingfeelabelGridItem: {
        css: css`
            flex-basis: auto;
            max-width: max-content;
            padding: 0;
            @media print {
                max-width: 50%;
                flex-basis: 50%;
                width: 50%;
                float: left;
            }
        `,
    },
    specialHandlingfeeValueGridItem: {
        css: css`
            flex-basis: auto;
            max-width: max-content;
            padding: 0;
            @media print {
                max-width: 50%;
                flex-basis: 50%;
                width: 50%;
                float: left;
            }
        `,
    },

 specialHandlingfeelabel: {
        css: css`
            font-weight: bold;
            padding-bottom: 5px;

            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal !important;
            letter-spacing: normal;
            color: ${getColor("text.main")};
            @media print {
                float: left;
                width: 50%;

            }
        `,
    },
    specialHandlingfeeValue: {
        css: css`
            font-weight: bold;
            padding-bottom: 5px;
            margin-left: -15px;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal !important;
            letter-spacing: normal;
            color: ${getColor("text.main")};
            margin-left: 200px;
            ${({ theme }) => { return breakpointMediaQueries(
                theme, [css`  margin-left: 10px;margin-right: 10px;`,],); 
            }}
            @media print {
                margin-left: 0;
                float: right;
                text-align: right;
                width: 50%;
            }
        `,
    },
    specialHandlingfeePerItemValue: {
        css: css`
            font-weight: bold;
            padding-bottom: 5px;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal !important;
            letter-spacing: normal;
            color: ${getColor("text.main")};
            margin-left: auto;
            margin-right: 25px;
            @media print {
                float: left;
            }
        `
    }
};




const ADISpecialHandlingFeeDisplay = ({
    session,
    orderLine,
    cartLine,
    extendedStyles
}: Props) => {

    const [styles] = useState(() => mergeToNew(adiSpecialHandlingFeeDisplayStyles, extendedStyles))
    const [Detailsdata, setDetailsdata] = useState(orderLine);
    const [cartLineData, setCartLinedata] = useState(cartLine);
 
   
    
    return (
        <>
       {Detailsdata && (<GridItem {...styles.specialHandlingfeeGridContainer}>
                            <GridItem {...styles.specialHandlingfeelabelGridItem}>
                            <Typography {...styles.specialHandlingfeelabel}>
                                {translate("Special Handling Fee")}
                            </Typography>
                        </GridItem>
                        <GridItem {...styles.specialHandlingfeeValueGridItem}>
                            <Typography {...styles.specialHandlingfeeValue} data-test-selector="orderDetails_specialHandlingFee">
                                {Detailsdata?.properties?.specialHandlingFeeDisplay}
                            </Typography>
                        </GridItem>
                            </GridItem>
       )}

       {cartLineData && (<GridItem {...styles.specialHandlingfeeGridContainer}>
        <GridItem {...styles.specialHandlingfeelabelGridItem}>
        <Typography {...styles.specialHandlingfeelabel}>
            {translate("Special Handling Fee")}
        </Typography>
    </GridItem>
    <GridItem {...styles.specialHandlingfeeValueGridItem}>
        <Typography {...styles.specialHandlingfeeValue} data-test-selector="orderPlacing_specialHandling_perItem">
            {cartLineData?.properties?.specialHandlingFee != "$0.00" && (`${cartLineData?.properties.specialHandlingFee.slice(0, 1)}${(Number(cartLineData?.properties.specialHandlingFee.slice(1)) / (cartLineData?.qtyOrdered || 1)).toFixed(2)}`)}
        </Typography>
        <Typography {...styles.specialHandlingfeeValue} data-test-selector="orderPlacing_specialHandling">
            {cartLineData?.properties?.specialHandlingFee}
        </Typography>
    </GridItem>
        </GridItem>
)}
</>
    );
};
export default connect(mapStateToProps)(ADISpecialHandlingFeeDisplay);
